'use client'

import { useRouter } from 'next/navigation'
import { useLingui } from '@lingui/react'

import { Button } from '@/components/ui/button'
import { Routes } from '@/constants/routes'
import React from 'react'

export default function NotFound(): React.JSX.Element {
  const { i18n } = useLingui()
  const router = useRouter()

  const handleGoBack = (): void => {
    router.back()
  }

  const handleBackToHome = (): void => {
    router.push(Routes.Root)
  }

  return (
    <div className='absolute left-1/2 top-1/2 mb-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center text-center'>
      <span className='bg-gradient-to-b from-foreground to-transparent bg-clip-text text-[10rem] font-extrabold leading-none text-transparent'>
        404
      </span>
      <h2 className='font-heading my-2 text-2xl font-bold'>{i18n._(`Something's missing`)}</h2>
      <p>{i18n._(`Sorry, the page you are looking for doesn't exist or has been moved.`)}</p>
      <div className='mt-8 flex justify-center gap-2'>
        <Button type='button' variant='default' size='lg' onClick={handleGoBack}>
          {i18n._(`Go back`)}
        </Button>
        <Button type='button' variant='ghost' size='lg' onClick={handleBackToHome}>
          {i18n._(`Back to Home`)}
        </Button>
      </div>
    </div>
  )
}
